<div class="w-full h-full overflow-hidden flex flex-col p-4 xl:p-5 2xl:p-6 mt-3 md:mt-5 xl:mt-0">
  <div class="mb-4 mt-4 shrink-0">
    <typography tag="h3" variant="h3" weight="bold" color="text-black"
      class="text-2xl xl:text-3xl 2xl:text-4xl min-[2560px]:text-8xl">
      Dashboard
    </typography>
  </div>

  <app-dashboard-stats class="mb-2 shrink-0 block"></app-dashboard-stats>

  <div class="bg-white rounded-lg shadow-sm border border-gray-100 flex-1 overflow-hidden flex flex-col">
    <div class="p-3 xl:p-4 2xl:p-5">
      <table-component
        [value]="attendance()"
        [columns]="columns"
        [showDateFilter]="true"
        [showHeaderFilters]="false"
        [rows]="rowsPerPage"
        [headerCellTemplate]="customHeaderTpl"
        [bodyCellTemplate]="customBodyTpl"
        [totalRecords]="totalRecords"
        (onPage)="refreshTableData($event)"
        (onLazyLoad)="refreshTableData($event)"
        >
      </table-component>
    </div>
  </div>
</div>

<ng-template #customHeaderTpl let-col>
  <typography variant="body-2" weight="semibold" color="text-black">
    {{ col.header }}
  </typography>
</ng-template>

<ng-template #customBodyTpl let-row let-col="col">
  <ng-container [ngSwitch]="col.field">
    <ng-container *ngSwitchCase="'employee'">
      <div class="flex items-center gap-2">
        <img *ngIf="row.employee?.photoUrl" [src]="row.employee.photoUrl"
          class="w-8 h-8 rounded-full object-cover border border-gray-200" alt="Profile">
        <div *ngIf="!row.employee?.photoUrl" [style.backgroundColor]="getRandomBg(row.employee?.name)"
          class="w-8! h-8! rounded-full flex items-center justify-center text-white text-[10px] font-bold border border-white shadow-sm">
          {{ getInitials(row.employee?.name) }}
        </div>
        <typography variant="body-3" weight="medium" color="text-black">{{ row.employee?.name }}</typography>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'clockIn'">
      <typography variant="body-3" weight="medium" color="text-black">
        <ng-container *ngIf="row.clockIn; else noTime">
          {{ '1970-01-01T' + row.clockIn | date:'hh:mm a' }}
        </ng-container>
        <ng-template #noTime>-</ng-template>
      </typography>
    </ng-container>

    <ng-container *ngSwitchCase="'manualEvidenceInUrl'">
      <div class="py-1">
        <img *ngIf="row.manualEvidenceInUrl" [src]="row.manualEvidenceInUrl" (click)="showPreview(row.manualEvidenceInUrl)"
          class="w-12! h-12! rounded-lg object-cover border border-gray-200 shadow-sm cursor-pointer hover:brightness-90 transition-all"
          title="Click to enlarge">
        <span *ngIf="!row.manualEvidenceInUrl" class="text-gray-400 italic text-[10px]">No Photo</span>
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <typography variant="body-3" weight="medium" color="text-black">{{ row[col.field] }}</typography>
    </ng-container>
  </ng-container>
</ng-template>

<p-dialog [(visible)]="displayPreview" [modal]="true" [showHeader]="false" [dismissableMask]="true"
  styleClass="preview-dialog" maskStyleClass="backdrop-blur-sm bg-black/60">

  <div class="relative w-full h-full flex flex-col items-center justify-center">

    <button (click)="displayPreview.set(false)"
      class="absolute top-[-20px] right-2 z-50 p-2 text-gray-800 transition-colors focus:outline-none">
      <i class="pi pi-times text-xl"></i>
    </button>

    <div class="photo-frame">
      <img [src]="previewUrl()" class="rounded-sm object-contain max-w-full max-h-full">
    </div>

  </div>
</p-dialog>
